import { TableColumnInfo } from "./TableColumnInfo";

class GridDisplaySettings {
    public OrderedColumns: TableColumnInfo[];
    public SortByColumn: string;
    public IsAscendingSort: boolean;
}

export { GridDisplaySettings };
